import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import styles from './AutoAnsweringTemplates.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import AddNewTemplates from './AddNewTemplates/AddNewTemplates'
import { checkPermList } from 'helpers'
import { permissions } from 'settings/permissions'
import Pagination from 'components/UI/Pagination/Pagination'

const initPagination = {
  page: 1,
  limit: 10,
}

export const AutoAnsweringTemplates = () => {
  const [templates, setTemplates] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [pagination, setPagination] = useState(initPagination)

  const fetchTemplates = async () => {
    setIsLoading(true)

    try {
      const response = await superAxiosRequest({
        link: 'integration/autoreply_templates',
        method: 'get',
        crm: true,
        params: {
          offset: (pagination.page - 1) * pagination.limit,
          limit: pagination.limit,
        },
      })
      setTemplates(response.data)
    } catch (err) {
      console.error('Ошибка загрузки шаблонов:', err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchTemplates()
  }, [pagination])

  const addTemplate = () => {
    const modalConfig = {
      modalBodyComponent: () => <AddNewTemplates />,
      link: 'integration/autoreply_templates',
      isResponsive: true,
      crm: true,
      title: 'Добавить шаблон',
      button: 'Сохранить',
      valid: {
        title: 'required',
        text: 'required',
        channel: 'required',
      },
      onSubmitSuccess: () => fetchTemplates(),
    }
    asideModalStore.activity(modalConfig, { is_active: true })
  }

  const editTemplate = (template) => {
    const modalConfig = {
      modalBodyComponent: () => <AddNewTemplates />,
      isResponsive: true,
      crm: true,
      title: 'Редактировать шаблон',
      button: 'Сохранить',
      is_put: true,
      link: `integration/autoreply_templates/${template.id}`,
      valid: {
        title: 'required',
        text: 'required',
        channel: 'required',
      },
      onSubmitSuccess: () => fetchTemplates(),
    }
    asideModalStore.activity(modalConfig, {
      channel: template.channel?.id,
      is_active: template.is_active,
      text: template.text,
      title: template.title,
    })
  }

  const deleteTemplate = (templateId) => {
    swal({
      title: 'Вы уверены?',
      text: 'Шаблон будет удален безвозвратно.',
      icon: 'warning',
      buttons: ['Отмена', 'Удалить'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        superAxiosRequest({
          method: 'delete',
          link: `integration/autoreply_templates/${templateId}`,
          crm: true,
        })
          .then(() => {
            fetchTemplates()
          })
          .catch((err) => {
            swal('Ошибка', 'Не удалось удалить шаблон', 'error')
            console.error('Ошибка удаления:', err)
          })
      }
    })
  }

  const handleMenuAction = (actionType, template) => {
    const actions = {
      edit_template: () => editTemplate(template),
      delete_template: () => deleteTemplate(template.id),
    }
    actions[actionType]?.()
  }

  const menuItems = [
    { name: 'Редактировать', action: 'edit_template' },
    { name: 'Удалить', action: 'delete_template' },
  ]

  const renderTemplateRow = (template, index) => (
    <div
      key={template.id}
      className={`${styles.templateRow} ${index % 2 === 0 ? styles.colorBg : ''}`}
    >
      <div className={styles.colTitle}>{template.title}</div>
      <div className={styles.colText}>{template.text}</div>
      <div className={styles.colChannel}>{template.channel?.name || '—'}</div>
      <div className={styles.colActive}>
        {template.is_active ? 'Да' : 'Нет'}
      </div>
      <div className={styles.colActions}>
        {checkPermList(permissions.edit_autoreply_templates_wazzup) && (
          <div className={styles.colActions}>
            <ActionMenu
              menu={menuItems}
              action={(actionType) => handleMenuAction(actionType, template)}
            />
          </div>
        )}
      </div>
    </div>
  )

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <PageHeader title='Шаблоны автоответов' />
        {checkPermList(permissions.edit_autoreply_templates_wazzup) && (
          <HeaderAddButton title='Добавить шаблон' onClick={addTemplate} />
        )}
      </div>

      {isLoading ? (
        <Loader />
      ) : templates?.result?.length === 0 ? (
        <div className={styles.noTemplates}>Нет добавленных шаблонов</div>
      ) : (
        <div className={styles.templatesList}>
          <div className={`${styles.templateRow} ${styles.headerRow}`}>
            <div className={styles.colTitle}>Имя шаблона</div>
            <div className={styles.colText}>Текст шаблона</div>
            <div className={styles.colChannel}>Канал</div>
            <div className={styles.colActive}>Активный</div>
            <div className={styles.colActions}></div>
          </div>
          {templates?.result?.map((template, index) =>
            renderTemplateRow(template, index),
          )}
        </div>
      )}
      <div className={styles.pagination}>
        {templates?._meta?.count_items > 5 && (
          <Pagination
            limit={pagination.limit}
            count={templates?._meta?.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}
